// Sidebar.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Nav, Col, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import SidebarItems from "./SidebarItems";
import Logo from "../images/Frame 1321317892.png";
import "../style/sidebar.css"; // Import the CSS file
import { useAuth } from "../utils/AuthContext";

function Sidebar({ defaultActive, user, minimized = false }) {
  const { logout } = useAuth();
  const location = useLocation();
  const lastActiveIndexString = localStorage.getItem("lastActiveIndex");
  const lastActiveIndex = Number(lastActiveIndexString);
  const [activeIndex, setActiveIndex] = useState(
    lastActiveIndex || defaultActive
  );

  function changeActiveIndex(newIndex) {
    localStorage.setItem("lastActiveIndex", newIndex);
    setActiveIndex(newIndex);
  }

  function getPath(path) {
    return path.charAt(0) !== "/" ? "/" + path : path;
  }

  useEffect(() => {
    const activeItem = SidebarItems.findIndex((item) => {
      return (
        item.route === getPath(location.pathname) ||
        (item.subcategories &&
          item.subcategories.find(
            (sub) => sub.route === getPath(location.pathname)
          ))
      );
    });
    changeActiveIndex(activeItem);
  }, [location]);

  const [subMenuOpen, setSubMenuOpen] = useState({});
  const [clickedIndex, setClickedIndex] = useState(null);

  const toggleSubMenu = (index) => {
    setSubMenuOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleMinimizedClick = (index) => {
    if (clickedIndex === index) {
      setClickedIndex(null);
    } else {
      setClickedIndex(index);
    }
  };

  // Fermer le menu flottant quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (minimized && clickedIndex !== null) {
        const isClickInside = event.target.closest('.sidebar-item-wrapper');
        const isClickInMenu = event.target.closest('.floating-submenu');
        if (!isClickInside && !isClickInMenu) {
          setClickedIndex(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [minimized, clickedIndex]);

  return (
    <Container className="scrollable-container" style={{height:'100%'}}>
      <Row>
        <Col className="sidePadding">
          <Nav className="flex-column">
            <Link to="/dashboard" className={minimized ? "logo-minimized" : ""}>
              <img className="myLogo" src={Logo} alt="LogoMarion" />
            </Link>

            {SidebarItems.map((item, index) => (
              <React.Fragment key={item.name}>
                {/* Afficher la barre de séparation si c'est un séparateur */}
                {item.separator ? (
                  <div
                    style={{
                      borderTop: '2px solid #dee2e6',
                      margin: '20px 15px',
                      opacity: 0.5
                    }}
                  />
                ) : (
                  <div className="sidebar-item-wrapper">
                    {item.subcategories ? (
                      <div
                        onClick={() => minimized ? handleMinimizedClick(index) : toggleSubMenu(index)}
                        className={`sidebar-item ${
                          index === activeIndex ? "active" : ""
                        }`}
                        title={minimized ? item.name : ""}
                      >
                        <p>
                          <img
                            className="CutomeSideBarIcon"
                            src={item.icon}
                            alt={item.name}
                          />
                          {!minimized && item.name}
                        </p>
                        {!minimized && (
                          <span className="dropdown-arrow">
                            {subMenuOpen[index] ? "▲" : "▼"}
                          </span>
                        )}
                      </div>
                    ) : (
                      <Link to={item.route} title={minimized ? item.name : ""}>
                        <div
                          className={`sidebar-item ${
                            index === activeIndex ? "active" : ""
                          }`}
                        >
                          <p>
                            <img
                              className="CutomeSideBarIcon"
                              src={item.icon}
                              alt={item.name}
                            />
                            {!minimized && item.name}
                          </p>
                        </div>
                      </Link>
                    )}

                    {/* Sous-menu normal (mode déplié) */}
                    {!minimized && item.subcategories && subMenuOpen[index] && (
                      <div className="subcategory-container">
                        {item.subcategories.map((subcategory, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subcategory.route}
                            className={`sidebar-item ${
                              getPath(subcategory.route) ===
                              getPath(location.pathname)
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>{subcategory.name}</p>
                          </Link>
                        ))}
                      </div>
                    )}

                    {/* Menu flottant (mode minimisé) - Affichage au clic */}
                    {minimized && item.subcategories && clickedIndex === index && (
                      <div className="floating-submenu">
                        <div className="floating-submenu-title">{item.name}</div>
                        {item.subcategories.map((subcategory, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subcategory.route}
                            onClick={() => setClickedIndex(null)}
                            className={`floating-submenu-item ${
                              getPath(subcategory.route) ===
                              getPath(location.pathname)
                                ? "active"
                                : ""
                            }`}
                          >
                            {subcategory.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}

            {!minimized && (
              <Row className="blurBG justify-content-center" style={{ marginTop: '100%'}}>
                <Col
                  className="mb-4 ml-4 d-flex align-items-end"
                  style={{ paddingLeft: "20px" }}
                >
                  <Image
                    src="https://questhowth.ie/wp-content/uploads/2018/04/user-placeholder.png"
                    alt="User Profile"
                    roundedCircle
                    style={{
                      width: "40px",
                      marginRight: "10px",
                      marginBottom: "3px",
                    }}
                  />
                  <div>
                    <h4>
                      {user ? `${user.prenom} ${user.nom}` : "Default Username"}
                    </h4>
                    <Nav.Link onClick={logout}>
                      <h5>Déconnexion</h5>
                    </Nav.Link>
                  </div>
                </Col>
              </Row>
            )}
          </Nav>
        </Col>
      </Row>
    </Container>
  );
}

export default Sidebar;
